import moment from 'moment';
import { ISO_DATE_FORMAT } from 'utils';
import { IClientFormData, IClientDataPayload } from '../models';

export function mapClientPayload(data: IClientFormData): IClientDataPayload {
	const {
		id,
		partnerId,
		formalName,
		shortName,
		domainName,
		website,
		color,
		logoData,
		contractStartDate,
		contractEndDate,
		contractData,
		clientUserCountLimit = '',
		surveyCountLimit = '',
		limitPerClientId = '',
		organizationIsicCode = '',
		integrationId = '',
		mailingListKey,
		comment,
		hasOngoingSurveys,
		hasPlannedSurveys,
	} = data;

	return {
		id: id as string,
		partnerId,
		formalName,
		shortName,
		domainName,
		website,
		color,
		logo: logoData,
		contractDto: {
			startDate: moment(contractStartDate).format(ISO_DATE_FORMAT),
			endDate: moment(contractEndDate).format(ISO_DATE_FORMAT),
			fileKey: contractData?.fileKey as string,
			fileUrl: contractData?.fileUrl as string,
		},
		surveyCountLimit: parseInt(`${surveyCountLimit}`, 10),
		limitPerClientId: parseInt(`${limitPerClientId}`, 10),
		clientUserCountLimit: parseInt(`${clientUserCountLimit}`, 10),
		organizationIsicCode: parseInt(organizationIsicCode, 10),
		integrationId: parseInt(integrationId, 10),
		comment,
		mailListKey: mailingListKey,
		hasOngoingSurveys,
		hasPlannedSurveys,
	};
}
